import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { AppDataProvider } from './context/AppDataContext.jsx';
import '@fontsource/inter';
import '@fontsource/poppins';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
    <AppDataProvider>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </AppDataProvider>
    </BrowserRouter>
  </React.StrictMode>
);